enum type {
  SET_PROVIDERS = 'SET_PROVIDERS',
  SET_LOADING_PROVIDERS = 'SET_LOADING_PROVIDERS',
}

export default type;